import Flex from "components/grid/Flex";
import { Typography } from "@material-ui/core";

const HistoryContainerAndTitle = ({ children, title, isVisible }) => {
    return (
        <Flex item grow={0} container column style={{ margin: "5px 0px", display: isVisible ? "block" : "none"}}>
            <Flex item style={{ borderBottom: "1px solid grey" }}>
                <Typography style={{ color: '#626262', fontStyle: "bold", fontSize: 14 }}>
                    {title}
                </Typography>
            </Flex>
            {children}
        </Flex>
    );
};

export default HistoryContainerAndTitle;
